export default class Faq
{
  constructor()
  {
    if (!this.setVars()) return;
    
    this.setEvents();
  }
  
  setVars()
  {
    this.settings = {
      main: 'data-faq',
      category: 'data-faq-category',
      item_categories: 'data-faq-categories',
      search: 'data-faq-search',
      search_input: 'data-faq-search-input',
      search_button: 'data-faq-search-button',
      search_select: 'data-faq-category-select',
    };
    
    this.faqs = document.querySelectorAll(`[${this.settings.main}]`);
    if (!this.faqs) return;
    
    return true;
  }
  
  setEvents()
  {
    this.faqs.forEach((faq) => {
      
      faq.querySelectorAll(`[${this.settings.category}]`).forEach((faq_category_button) => {
        
        faq_category_button.addEventListener('click', (e) => {
  
          faq.querySelectorAll(`[${this.settings.category}]`).removeClass('active');
          faq.querySelectorAll(`[${this.settings.item_categories}]`).removeClass('active');
          faq.querySelector(`[${this.settings.search_input}]`).value = '';
          
          faq_category_button.addClass('active');
          const category = e.target.getAttribute(this.settings.category);
          
          faq.querySelectorAll(`[${this.settings.item_categories}]`).forEach((item_categories) => {
            const categories = item_categories.getAttribute('data-faq-categories').split(",");
            
            if (categories.indexOf(category) !== -1) {
              item_categories.addClass('active');
            } else if (category === 'all') {
              item_categories.addClass('active');
            }
          })
        });
      });
      
      const search_input = faq.querySelector(`[${this.settings.search_input}]`);
      const search_button = faq.querySelector(`[${this.settings.search_button}]`);
      const search_select = faq.querySelector(`[${this.settings.search_select}]`);
      
      if (search_input) {
        search_input.addEventListener('keyup', (e) => {
          faq.querySelectorAll(`[${this.settings.item_categories}]`).removeClass('active');
          this.toggleSearchInputItems(faq, e.target.value);
        })
      }
      
      if (search_button) {
        search_button.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
        
          faq.querySelectorAll(`[${this.settings.item_categories}]`).removeClass('active');
          this.toggleSearchInputItems(faq, faq.querySelector(`[${this.settings.search_input}]`).value);
        })
      }
      
      if (search_select) {
        search_select.addEventListener('change', (e) => {
    
          faq.querySelectorAll(`[${this.settings.category}]`).removeClass('active');
          faq.querySelectorAll(`[${this.settings.item_categories}]`).removeClass('active');
          const category = e.target.value;
    
          faq.querySelectorAll(`[${this.settings.item_categories}]`).forEach((item_categories) => {
            const categories = item_categories.getAttribute('data-faq-categories').split(",");
      
            if (categories.indexOf(category) !== -1) {
              item_categories.addClass('active');
            } else if (category === 'all') {
              item_categories.addClass('active');
            }
          })
        })
      }
    });
  }
  
  toggleSearchInputItems(faq, search_string) {
    faq.querySelectorAll(`[${this.settings.item_categories}]`).forEach((item) => {
      if (item.getAttribute('data-faq-title').toLowerCase().indexOf(search_string.toLowerCase()) !== -1) {
        item.addClass('active');
      } else if (!search_string.length) {
        item.addClass('active');
      }
    });
  }
}
